import './style.scss';

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { filterAndOrderList } from '../../../utils/utils';
import Filter from '../../components/filter';
import { Tags } from '../../components/tags';
import DataTable from './DataTable';

const ROLES_FILTER_KEYS = ['name'];

const Language = ({ languageList, loading, fetchAllLanguages, languageDelete }) => {
  const navigate = useNavigate();
  const [filtered, setFiltered] = useState();
  const [reset, setReset] = useState(false);

  useEffect(() => {
    fetchAllLanguages && fetchAllLanguages();
  }, []);

  const onFilter = (result) => {
    if (!result) setFiltered(null);
    else {
      setFiltered(result.map((r) => r.item.id));
      setReset(!reset);
    }
  };

  const onModify = (lng) => {
    navigate(`/languages/${lng.id}`, lng);
  };

  const onDelete = (ids) => {
    languageDelete(ids);
  };

  const exportDataToXls = () => {
    return Array.isArray(filtered) ? languageList.filter((r) => filtered.includes(r.Id)) : languageList;
  };

  return (
    <>
      <Tags exportFct={exportDataToXls} />
      <Filter languageList={languageList} onFilter={onFilter} keys={ROLES_FILTER_KEYS} />

      <DataTable
        items={filterAndOrderList(languageList, filtered)}
        reset={reset}
        loading={loading}
        itemClick={onModify}
        onDelete={onDelete}
        onModify={onModify}
      />
    </>
  );
};

export default Language;
